module.exports = __webpack_public_path__ + "img/bg_pattern.eba02d8.jpg";